






































import { Pracovnik } from '@/modules/administrace/pracovnik';
import { listFactory } from '@/main/pages';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { PROrders } from '@/modules/sklad/PROrders';

import { NAME } from './constants';
import { store } from './store/list';
import { listMutations } from './store/types';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		DodavatelSelect: Dodavatel.components.Select,
		PracovnikSelect: Pracovnik.components.Select,
		PrordersSelect: PROrders.components.Select,
	},
	created() {
		apiProvider.processPartsReceiptFile();
	},
	data() {
		return {
			prijemkaLabels: {
				Otevrena: 0,
				UzavrenaKorNc: 1,
				Uzavrena: 2,
				Vyrazena: 3,
			},
		};
	},
	computed: {
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${listMutations.ND_PRIJEMKA_DODAVATEL_FILTER_SELECT_MAPPER}`,
				vstupPrac: `${this.storeUri}/${listMutations.ND_PRIJEMKA_VSTUP_PRAC_FILTER_SELECT_MAPPER}`,
				prorders: `${this.storeUri}/${listMutations.ND_PRIJEMKA_FILTER_PRORDERS_SELECT_MAPPER}`,
			};
		},
		enableUzavreno() {
			return !(this.Vyrazena || this.Uzavrena);
		},
		archivPrijmuND() {
			return this.LocalizePopisostatni('chkPrijemkaNDArchiv');
		},
	},
	methods: {
		processClick(event: any) {
			const receiptId = event.data.PRIJEMKA_ID > 0 ? event.data.PRIJEMKA_ID : event.data.ID;
			openEdit(NAME, PageMode.EDIT, { id: receiptId, isZpracujMode: true });
		},
	},
});
